const SlidersData = [
  { source: "img/slider/2.png", alt: "اجاره نردبان" },
  { source: "img/slider/3.png", alt: "اجاره هیلتی" },
  { source: "img/slider/4.png", alt: "اجاره فارسی ‌بر" },
 
];

export { SlidersData };
